import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'currentDateTime'
})
export class CurrentDateTimePipe implements PipeTransform {

  zeroString(v) {
    if (v < 10) {
      return '0' + v.toString();
    } else {
      return v.toString();
    }
  }

  convert2string(date) {
    const year = date.getFullYear();
    const month = this.zeroString(date.getMonth() + 1);
    const day = this.zeroString(date.getDate());
    const hour = this.zeroString(date.getHours());
    const min = this.zeroString(date.getMinutes());
    return hour + ':' + min + ' ' + day + '.' + month + '.' + year;
  }

  transform(value: string): string {
    const delta = new Date().getTimezoneOffset() / 60;
    const datetime = value.split(' ');

    const minute = parseInt(datetime[1].split(':')[1]);
    const hour = parseInt(datetime[1].split(':')[0]);
    const day = parseInt(datetime[0].split('.')[0]);
    const month = parseInt(datetime[0].split('.')[1]) - 1;
    const year = parseInt(datetime[0].split('.')[2]);

    const t = new Date(year, month, day, hour, minute).getTime();

    const newtime = new Date(t - (delta * 3600000));
    return this.convert2string(newtime);
  }

}
